import { useReduxState } from 'hooks';
import { User } from 'components/common';
import { getMessageWithPlaceholders } from 'shared-locales';
import { getFormattedDate } from 'lib/common';
import { getUserDisplayName } from 'shared-helpers/common';

import type { Achievement, AchievementData } from 'shared-types';

interface Props {
  achievement: Pick<Achievement, 'allowClosingConversationRequireApproval'>;
  achievementData: Pick<
    AchievementData,
    'isConfidential' | 'confidentialUsers'
  >;
}

const AchievementCompletionClosingApprovalHistory: React.FC<Props> = ({
  achievement,
  achievementData
}) => {
  const { messages, serverConfig, theme } = useReduxState();

  const isConfidentialWithApproval =
    achievementData.isConfidential &&
    achievement.allowClosingConversationRequireApproval;

  if (
    !isConfidentialWithApproval ||
    !achievementData.confidentialUsers ||
    !achievementData.confidentialUsers.some((cu) => cu.closingApprovalDate)
  ) {
    return null;
  }

  return (
    <div className="approval-history">
      {achievementData.confidentialUsers
        .filter((cu) => cu.closingApprovalDate)
        .sort(
          (a, b) =>
            new Date(b.closingApprovalDate as string).getTime() -
            new Date(a.closingApprovalDate as string).getTime()
        )
        .map((cu) => (
          <div key={cu.UserId} className="approval-history__item">
            <User
              showEmail={false}
              showNameOrUsername={false}
              size="tiny"
              style={{ marginRight: 5 }}
              user={cu.User}
            />
            <div className="approval-history__text">
              {getMessageWithPlaceholders({
                message:
                  messages.achievementCompletionCloseConversationApprovedBy,
                placeholders: {
                  userName: getUserDisplayName({
                    messages,
                    serverConfig,
                    user: cu.User
                  }),
                  date: getFormattedDate({ date: cu.closingApprovalDate })
                }
              })}
            </div>
          </div>
        ))}

      <style jsx>{`
        .approval-history {
          margin-top: 10px;
        }
        .approval-history__text {
          display: inline-block;
          vertical-align: middle;
        }
        .approval-history__item {
          color: ${theme.textColorLighter};
          font-size: 1.3rem;
          padding: 5px 0;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default AchievementCompletionClosingApprovalHistory;
